export default __webpack_public_path__ + "static/media/contactus-bg2.c0435f50.jpg";